import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class WindowMessageService {
  public send(event: any): void {
    window.postMessage({ type: event.type }, `${window.location.protocol}//${window.location.host}`);
  }
}
